import loginedApi,{FILEURL} from "../apis"
import CryptoJS from "crypto-js";
import { convertDateToString, convertDateToStringOneYear, convertDateToStringThreeMonthBack } from "../Helpers/dateFunctions";
import { getFromLocalStorage } from "../Helpers/localStorageHelper";
import { ADMIN_USER, CLINIC_ADMIN, USER_DATA } from '../constants/const'
import authHeader from "./AuthHeader";
import { INTERBRANCH_ADMIN_CONSOLIDATED, INTERBRANCH_ADMIN_DASHBOARD, INTERBRANCH_ADMIN_DASHBOARD_SELECTED, INTERBRANCH_ADMIN_DASHBOARD_SELECTED_v2, INTERBRANCH_ADMIN_DETAILED, INTERBRANCH_ADMIN_DETAILED_SELECTED, MANAGE_HOSPITALS_LIST, MANAGE_SESSION } from "./type";

var hashcode = CryptoJS.SHA256(process.env.REACT_APP_PREFIX+process.env.REACT_APP_TOKEN+process.env.REACT_APP_SECRETKEY);
const { detect } = require('detect-browser');
const browser = detect();
let platform = window.navigator.platform;
let userAgent = window.navigator.userAgent;


let off = new Date().toString().replace(/GMT\+(\d\d)(\d\d)/, "GMT+$1:$2");
let formatTime = off?.split("GMT")[1].split(" (")[0];
let result = formatTime?.slice(1);
if (formatTime.search(/\+/g) != null) {
  formatTime = formatTime.replace(/\+/g, "%2B")
} else if (formatTime.search(/\-/g) != null) {
  formatTime = formatTime.replace(/\-/g, "%2D")
}//replace(/\+/g,' ') browserTimeZone: `GMT${formatTime}`


export const downloadAppointmentDoctorReport = (_para) => async (dispatch) => {


    let fromDate = _para?.fromDate ? convertDateToString(_para.fromDate) : convertDateToStringThreeMonthBack(convertDateToString(new Date()))
    let toDate = _para?.toDate ? convertDateToString(_para.toDate) : convertDateToString(new Date())

    let userData = await getFromLocalStorage(USER_DATA)
    userData = JSON.parse(userData)
    let { userType, clinicId } = userData


    //console.log(fromDate, toDate);

    let params = {
        "token":hashcode.toString(),
        "requestType": "1900",
        "version": "2.0",
        "data": {
            // "clinicId": "62",
            "offset": 0,
            "browserTimeZone": "GMT+05:30",
            "Type": "excel",

        }
    }

    if (userType == ADMIN_USER) {
    }
    else if (userType == CLINIC_ADMIN) {

        params.data.clinic = clinicId

    }

    let response = await loginedApi.post("getdoctordetails", params, { headers: authHeader() })

    //console.log("getsummaryreport responce ->", responce.data.data);

    if (response.status == "200") {

        if (response.data.errorType != "FAILURE" && response.data?.data) {


            if (response.data?.data?.filename) {
                return FILEURL+`?requestType=256&uploadBy=ConsultationProcess&name=${response.data?.data?.filename}&type=Attachement&uploadRefId=123&from=web`
            }


        }
        else {

            dispatch({ type: MANAGE_SESSION, payload: { isSessionActive: false } });
        }
    }
}

export const downloadAppointmentPatientReport = (_para,name) => async (dispatch) => {


    let fromDate = _para?.fromDate ? convertDateToString(_para.fromDate) : convertDateToStringThreeMonthBack(convertDateToString(new Date()))
    let toDate = _para?.toDate ? convertDateToString(_para.toDate) : convertDateToString(new Date())

    let userData = await getFromLocalStorage(USER_DATA)
    userData = JSON.parse(userData)
    let { userType, clinicId } = userData


    console.log(fromDate, _para);

    let params = {
        "token":hashcode.toString(),
        "requestType": "2000",
        "version": "2.0",
        "data": {
            SearchType:_para?.SearchType,
            patientName:_para?.patientName,
            patientNumber: _para?.patientNumber,
            patientEmail:_para?.patientEmail,
            // "clinicId": "62",
            "offset": 0,
            "browserTimeZone": "GMT+05:30",
            "Type": "excel",
          

        }
        
    }

    if (userType == ADMIN_USER) {
    }
    else if (userType == CLINIC_ADMIN) {

        params.data.clinic = clinicId

    }

    let response = await loginedApi.post("getpatientdetails", params, { headers: authHeader() })

    //console.log("getsummaryreport responce ->", responce.data.data);

    if (response.status == "200") {

        if (response.data.errorType != "FAILURE" && response.data?.data) {


            if (response.data?.data?.filename) {
                return FILEURL+`?requestType=256&uploadBy=ConsultationProcess&name=${response.data?.data?.filename}&type=Attachement&uploadRefId=123&from=web`
            }


        }
        else {

            dispatch({ type: MANAGE_SESSION, payload: { isSessionActive: false } });
        }
    }
}

export const fetchdoctors = (offset) =>  async (dispatch) => {

        let res = await loginedApi.post("getdoctordetails", {
            token : hashcode.toString(),
            data: {
                browserTimeZone : `GMT${formatTime}`,
                useragent: userAgent,
                Browser: browser.name + " " + browser.version,
                appname: "C2MD Web",
                Os: platform,
                offset: offset,
            },
            requestType: 1900,
        });
        console.log(res);
        return res.data.data;
    };

    export const fetchpatients = (offset, type, value) => async (dispatch) => {
        let res = await loginedApi.post("getpatientdetails", {
          token: hashcode.toString(),
          data: {
            browserTimeZone: `GMT${formatTime}`,
            SearchType: type,
            patientName: type === "byName" ? value : "",
            patientNumber: type === "byNumber" ? value : "",
            patientEmail: type === "byEmail" ? value : "",
            useragent: userAgent,
            Browser: browser.name + " " + browser.version,
            appname: "C2MD Web",
            Os: platform,
            offset: offset,
          },
          requestType: 2000,
        });
        console.log(res);
        return res.data.data;
      };

    export const updateStatus = (userId, status) =>  async (dispatch) => {
        console.log('data...', userId)

      let res = await loginedApi.post("updatestatus", {
          token : hashcode.toString(),
          data: {
              userId: userId,
              status: status,
              browserTimeZone : `GMT${formatTime}`,
              useragent: userAgent,
              Browser: browser.name + " " + browser.version,
              appname: "C2MD Web",
              Os: platform,
          },
          requestType: 2010,
      });
      console.log(res);
      return res.data.data;
  };

export const resetPassword = (userId, password) => async(dispatch) => {

    var hash = CryptoJS.SHA512("C2MD|Welcome");

    let res = await loginedApi.post("resetpassword", {
        token: hashcode.toString(),
        data: {
            userId: userId,
            hashPassword: hash.toString(CryptoJS.enc.Base64),
            password: hash.toString(),
            browserTimeZone : `GMT${formatTime}`,
            useragent: userAgent,
            Browser: browser.name + " " + browser.version,
            appname: "C2MD Web",
            Os: platform,
        },
        requestType: 2011,
    });
    console.log(res);
    return res.data.data;


}; 


export const getPatientDetails = (patientId) => async(dispatch) => {

    let res = await loginedApi.post("getpatientbyid", {
        token: hashcode.toString(),
        data: {
            patientId: patientId,
            browserTimeZone : `GMT${formatTime}`,
            useragent: userAgent,
            Browser: browser.name + " " + browser.version,
            appname: "C2MD Web",
            Os: platform,
        },
        requestType: 2011,
    });
    console.log(res);
    return res.data.data;


}; 

export const searchbyname = (name,offset) => async(dispatch) => {

    let res = await loginedApi.post("getpatientnames", {
        token: hashcode.toString(),
        data: {
            patientName: name,
            browserTimeZone : `GMT${formatTime}`,
            useragent: userAgent,
            Browser: browser.name + " " + browser.version,
            appname: "C2MD Web",
            Os: platform,
            offset: offset,
        },
        requestType: 2011,
    });
    console.log(res);
    return res.data.data;


}; 

export const updateprofileinformation = (formdata) => async(dispatch) => {

    let res = await loginedApi.post("updateprofileinformationuser", {
        token: hashcode.toString(),
        data:formdata,
        requestType: 2012,
    });
    console.log(res);
    return res.data.data;


}; 


